/**
 * Lightweight haptics wrapper. Uses navigator.vibrate where available
 * (Android Chrome + some PWAs). No-ops on iOS Safari — there it's a visual-only
 * affordance via :active scale. Never throws.
 */
type Pattern = "light" | "medium" | "heavy" | "success" | "warning" | "error" | "selection";

const PATTERNS: Record<Pattern, number | number[]> = {
  selection: 8,
  light: 10,
  medium: 18,
  heavy: 30,
  success: [12, 40, 12],
  warning: [20, 60, 20],
  error: [30, 50, 30, 50, 30],
};

const canVibrate = () =>
  typeof navigator !== "undefined" && typeof navigator.vibrate === "function";

export const haptics = {
  trigger(pattern: Pattern = "light") {
    if (!canVibrate()) return;
    try {
      navigator.vibrate(PATTERNS[pattern]);
    } catch {
      /* silently ignore */
    }
  },
};

export default haptics;
